import type Player from "../models/colyseus-models/player"
import type { Egg } from "../models/colyseus-models/pokemon"
import PokemonFactory from "../models/pokemon-factory"
import { getPokemonData } from "../models/precomputed/precomputed-pokemon-data"
import { PRECOMPUTED_POKEMONS_PER_RARITY } from "../models/precomputed/precomputed-rarity"
import { PokemonActionState } from "../types/enum/Game"
import { Pkm } from "../types/enum/Pokemon"
import { getFirstAvailablePositionInBench } from "../utils/board"
import { pickRandomIn } from "../utils/random"
import { getHatchTime } from "./evolution-logic/hatch-time"

export function createRandomEgg(player: Player, shiny: boolean): Egg {
  const hatchList = PRECOMPUTED_POKEMONS_PER_RARITY.HATCH.filter(
    (p) => getPokemonData(p).stars === 1
  )
  const egg = PokemonFactory.createPokemonFromName(Pkm.EGG, { shiny }) as Egg
  egg.action = PokemonActionState.SLEEP
  egg.stacksRequired = getHatchTime(egg, player)

  if (player) {
    const remainingEggs = hatchList.filter(
      (p) => !player.randomEggsGiven.includes(p)
    )
    egg.evolution = pickRandomIn(
      remainingEggs.length > 0 ? remainingEggs : hatchList
    )
    player.randomEggsGiven.push(egg.evolution)
  } else {
    egg.evolution = pickRandomIn(hatchList)
  }

  return egg as Egg
}

export function giveRandomEgg(player: Player, shiny = false): Egg | undefined {
  const egg = createRandomEgg(player, shiny)

  const x = getFirstAvailablePositionInBench(player.board)
  if (x !== null) {
    egg.positionX = x
    egg.positionY = 0
    player.board.set(egg.id, egg)
    player.pokemonsPlayed.add(Pkm.EGG)
    return egg
  }
}
